import { createSelector } from 'reselect'
import { getActiveServerId } from '../activeServer/selectors'

export const getProgresses = state => state.backendReducer.progress || {}
export const getProgressForServer = (state, serverId) => {
    const progresses = getProgresses(state)
    return progresses[serverId] || { percent: 0, message: '' }
}
export const getActiveProgress = createSelector(
    [getActiveServerId, getProgresses],
    (active, progresses) => progresses[active] || { percent: 0, message: '' },
)



// WEBPACK FOOTER //
// ./src/features/Backend/data/progress/selectors.js